import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getLanguageDirection } from '@/i18n/config';

export const useLanguage = () => {
  const { i18n } = useTranslation();
  
  useEffect(() => {
    // Update document direction based on current language
    const direction = getLanguageDirection(i18n.language);
    document.documentElement.dir = direction;
    document.documentElement.lang = i18n.language;
    
    // Add or remove RTL class to body for CSS styling
    if (direction === 'rtl') {
      document.body.classList.add('rtl');
    } else {
      document.body.classList.remove('rtl');
    }
  }, [i18n.language]);

  const changeLanguage = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };

  const isRTL = getLanguageDirection(i18n.language) === 'rtl';

  return {
    currentLanguage: i18n.language,
    changeLanguage,
    isRTL,
    direction: getLanguageDirection(i18n.language)
  };
}; 